import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';

import {KeyDateService} from 'app/service/key-date.service';
import {BaseTranslateLoader, BasicVsciModule} from '@visana-web/basic-ui';
import {WaitingComponent} from 'app/component/waiting/waiting.component';
import {SearchCriteriaComponent} from 'app/component/search-criteria/search-criteria.component';
import {SearchResultComponent} from 'app/component/search-result/search-result.component';
import {SearchResultEntryComponent} from 'app/component/search-result/search-result-entry/search-result-entry.component';
import {TranslateLoader, TranslateService} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';


export class CustomLoader extends BaseTranslateLoader {
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.translateUrl = '/webresources/imprestAccount/r4/textModules';
  }
}

export function createTranslateLoader(httpClient: HttpClient): TranslateLoader {
  return new CustomLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    WaitingComponent,
    SearchCriteriaComponent,
    SearchResultComponent,
    SearchResultEntryComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot([]),
    BasicVsciModule.forRoot(),
    InfiniteScrollModule,
    BasicVsciModule.forTranslationRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
        useClass: CustomLoader
      }
    }),
  ],
  providers: [
    CookieService,
    TranslateService,
    KeyDateService,
    {provide: 'googleTagManagerId', useValue: 'GTM-5XX55G'}
  ],
  bootstrap: [AppComponent]
})


export class AppModule {
}
